import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://ikjvlphtlmnunknytwvb.supabase.co'
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'sb_publishable_wMOZaUQ52WiifPU-f85Irw_-G8rU9T5'

export const supabase = createClient(supabaseUrl, supabaseKey)